import React from "react";
import styles from "./PageTitleWithLeaf.module.css";

const PageTitleWithLeaf = ({ text, textClassname, className }) => {
  if (!text) return null;
  const newText = text.trim();
  const lastChar = newText[newText.length - 1]; // Correctly get the last character
  const textWithoutLastChar = newText.slice(0, -1); // Remove the last character

  return (
    <div className={`${className || ""} ${styles.headingMainContainer}`}>
      <h1 className={`${textClassname || ""} ${styles.pageTitle}`}>
        {textWithoutLastChar}

        <span style={{ position: "relative" }}>
          {lastChar}
          <img
            src="/assets/images/home/leafImage.png"
            alt="leaf"
            loading="lazy"
            className={styles.leafImage}
          />
        </span>
      </h1>
    </div>
  );
};

export default PageTitleWithLeaf;
